import React from 'react';

const Electricity = props => (
  <svg
    width={21}
    height={32}
    viewBox="0 0 21 32"
    preserveAspectRatio="xMidYMid"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.407 12.736 8.121 31l2.46-11.74H.752L13.039 1l-2.46 11.736h9.828Z"
      stroke="#FAFAFA"
      strokeLinejoin="round"
    />
  </svg>
);

export default Electricity;
